import { isInTriageMode } from 'pages/alerts/utils';

import { createContexts } from '../../utils';
import { getIntelView } from '../utils';

import type { SnowplowSchemaName } from '../../schemas';
import type { EventDefinition } from '../../types';

export const intel_action: EventDefinition = {
  getData: (action, eventData = {}) => {
    const triageMode = isInTriageMode();
    const view = getIntelView(eventData);
    const rank = triageMode ? 1 : eventData?.rank;
    return action && eventData
      ? {
          type: action,
          view,
          label: eventData?.label,
          rank,
        }
      : {};
  },
  addContexts: ({ action, eventData, filterData } = {}) => {
    const commonContexts = createContexts(['intel'], { eventData });
    const view = getIntelView(eventData);
    const includeIntelFilter = view === 'list' || view === 'triage';

    const contexts = [...commonContexts];

    if (includeIntelFilter) {
      const intelFilterContext = createContexts(['intelfilter'], {
        eventData,
        filterData,
        transformers: {
          intelfilter: (eventData, filterData) => ({
            ...filterData,
            ...eventData.intelfilter,
          }),
        },
      });
      contexts.push(...intelFilterContext);
    }

    if (!action) return contexts;

    const actionContextMap: Record<string, SnowplowSchemaName[]> = {
      board: ['board'],
      tag: ['tag'],
      why_it_matters: ['comment'],
    };

    const actionEntity = action.replace(/^(?:add|edit|remove)_(.*)$/gi, '$1');

    const actionContexts = createContexts(
      actionContextMap[actionEntity] || [],
      { eventData },
    );

    return [...contexts, ...actionContexts];
  },
};
